import { commerceQuerySetReducer as querySetReducer } from './commerce-query-set-slice.js';
import { registerQuerySetQuery, updateQuerySetQuery, } from './query-set-actions.js';
/**
 * Loads the query set reducer and returns the available query set action creators.
 *
 * @param engine - The commerce engine.
 * @returns An object holding the query set action creators.
 *
 * @group Actions
 * @category QuerySet
 */
export function loadQuerySetActions(engine) {
    engine.addReducers({ querySetReducer });
    return {
        registerQuerySetQuery,
        updateQuerySetQuery,
    };
}
